module.exports = __webpack_public_path__ + "img/google-play.dc170672.png";